import { getEnv } from "#app/lib/env";

/**
 * The API service base URLs, resolved from env once — the single home for
 * these env keys and their dev defaults. Every service exposes
 * unauthenticated REST `GET /health` and `GET /version` off its base (see
 * each service's main.ts); GraphQL endpoints hang off the same bases.
 *
 * Deployed containers always inject the env vars (window.__env__), so the
 * defaults only apply in dev. There they derive the host from
 * `location.hostname` rather than hardcoding `localhost`: the services bind
 * all interfaces, so a browser on another machine that loads the app via the
 * dev box's LAN IP reaches every service on that same IP. A hardcoded
 * `localhost` default would point at the *viewer's* machine and silently
 * break cross-machine dev (auth works, flags/analytics vanish).
 */
function devServiceBase(port: number): string {
  const host =
    typeof window !== "undefined" && window.location?.hostname
      ? window.location.hostname
      : "localhost";
  return `http://${host}:${port}`;
}

export const CORE_API_BASE = getEnv("EXPO_PUBLIC_CORE_API", devServiceBase(3000));

export const AUTH_API_BASE = getEnv("EXPO_PUBLIC_LOGIN_URL", devServiceBase(3001));

/** The flags env var points at the service's GraphQL endpoint, not its root. */
export const FEATURE_FLAGS_GRAPHQL_URL = getEnv(
  "EXPO_PUBLIC_FLAGS_API",
  `${devServiceBase(3002)}/graphql`,
);

export const ANALYTICS_API_BASE = getEnv(
  "EXPO_PUBLIC_ANALYTICS_API",
  devServiceBase(3003),
);
